// Confirms a domain_filter guard rejection from the error string ConnectApp
// forwards (it has no structured field for it). Source of truth for the
// message wording: monolith domain_filter.py:121-133. Fails closed — returns
// undefined for anything that doesn't match, so a wording change degrades to
// "no banner" rather than a mislabeled one.
const DOMAIN_REJECTION_RE =
  /Domain '([^']+)' is (?:not in the allowed list|in the denied list)/;

export const parseDomainRejection = (
  errorDescription: string | undefined,
): { domain: string } | undefined => {
  const match = errorDescription?.match(DOMAIN_REJECTION_RE);
  return match ? { domain: match[1] } : undefined;
};
